import { Buffer } from 'buffer';
export const encodeBase64 = (text = '') => {
    const textKey = 'DGA_LAW_FRONTEND';
    const decode = Buffer.from(text + textKey).toString('base64');
    return decode;
};


